import axios from 'axios'
import { ApiRequestFailedException, ApiResponseNotSuccessfulException, UnauthenticatedException } from '@/common/errors'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
import _ from 'lodash'

axios.defaults.withCredentials = true

const showNeedLoginAndGoLogin = _.throttle(() => {
  Message({
    type: 'error',
    message: '您尚未登录，即将为您跳转到登录页',
    onClose: () => {
      const currentUrl = router.currentRoute.fullPath
      // const currentUrl = window.location.pathname
      const returnUrl = encodeURIComponent(currentUrl)
      // router.replace({
      //   name: 'login',
      //   query: {
      //     returnUrl
      //   }
      // })
      window.location.replace(`/login?returnUrl=${returnUrl}`)
    }
  }, 1000)
}, 10000)

const interceptorSuccess = (response) => {
  const apiResponse = response.data
  const code = apiResponse.code

  if (code !== 200) {
    if (code === 401) {
      store.commit('auth/CLEAR')
      showNeedLoginAndGoLogin()
      throw new UnauthenticatedException()
    } else {
      throw new ApiResponseNotSuccessfulException(code, apiResponse.message)
    }
  }

  return apiResponse.result
}

const interceptorError = (error) => {
  window.console.dir(error)
  throw new ApiRequestFailedException(`请求服务器失败[${error.message}]`)
}

axios.interceptors.response.use(interceptorSuccess, interceptorError)

export default axios
